import "./AdminOps.css";

function OpsMetric({ title, value, detail, tone = "blue" }) {
  return (
    <article className={`admin-ops-metric tone-${tone}`}>
      <span>{title}</span>
      <strong>{value}</strong>
      <small>{detail}</small>
    </article>
  );
}

export function AdminOpsShell({ eyebrow, title, description, metrics, toolbar, children, heroClassName = "" }) {
  return (
    <section className="admin-ops-page">
      <article className={["admin-ops-hero", heroClassName].filter(Boolean).join(" ")}>
        <div className="admin-ops-hero-copy">
          <p className="admin-ops-eyebrow">{eyebrow}</p>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        {toolbar ? <div className="admin-ops-toolbar">{toolbar}</div> : null}
      </article>

      {metrics?.length ? (
        <section className="admin-ops-metric-grid">
          {metrics.map((item) => (
            <OpsMetric key={item.title} {...item} />
          ))}
        </section>
      ) : null}

      {children}
    </section>
  );
}

export function AdminInquiryHubPage({ locale, selectedInquiryCount, inquirySummary, toolbar, table }) {
  const isZh = locale === "zh";

  return (
    <AdminOpsShell
      eyebrow={isZh ? "询盘运营中心" : "Inquiry Operations Hub"}
      title={isZh ? "询盘中心" : "Inquiry Center"}
      description={isZh ? "统一处理询盘、批量读写状态和外部联系入口，让询盘页和其他后台页保持一致的管理体验。" : "Handle inquiries, batch read-state actions, and contact-center access in a page consistent with the rest of the admin."}
      toolbar={toolbar}
      metrics={[
        { title: isZh ? "当前页记录" : "Rows on Page", value: inquirySummary.pageCount, detail: isZh ? "当前页可见询盘数" : "Visible inquiries on this page", tone: "blue" },
        { title: isZh ? "已选条目" : "Selected", value: selectedInquiryCount, detail: isZh ? "可执行批量操作" : "Available for batch actions", tone: "violet" },
        { title: isZh ? "总询盘数" : "Total Inquiries", value: inquirySummary.totalCount, detail: isZh ? "后台累计询盘记录" : "Total inquiries tracked", tone: "emerald" }
      ]}
    >
      <div className="admin-ops-surface">{table}</div>
    </AdminOpsShell>
  );
}

export function AdminTeamPermissionsPage({ locale, userCount, activeCount, toolbar, table }) {
  const isZh = locale === "zh";

  return (
    <AdminOpsShell
      eyebrow={isZh ? "团队权限中心" : "Team Permissions Center"}
      title={isZh ? "成员与权限" : "Members and Permissions"}
      description={isZh ? "把成员管理、角色状态和账号操作收进统一的权限工作台，不再直接暴露旧版表格壳。" : "Bring member management, role state, and account actions into one permissions workspace instead of exposing the old table shell."}
      toolbar={toolbar}
      metrics={[
        { title: isZh ? "成员总数" : "Total Members", value: userCount, detail: isZh ? "当前后台成员记录" : "Current managed user rows", tone: "blue" },
        { title: isZh ? "活跃账号" : "Active Accounts", value: activeCount, detail: isZh ? "当前可正常使用" : "Currently active accounts", tone: "emerald" },
        { title: isZh ? "权限工作台" : "Permission Workspace", value: isZh ? "已统一" : "Unified", detail: isZh ? "纳入统一后台壳层" : "Integrated into the shared admin shell", tone: "amber" }
      ]}
    >
      <div className="admin-ops-surface">{table}</div>
    </AdminOpsShell>
  );
}

export function AdminSiteMaintenanceHubPage({ locale, metrics, toolbar, leftPanel, rightPanel }) {
  const isZh = locale === "zh";

  return (
    <AdminOpsShell
      eyebrow={isZh ? "站点维护中心" : "Site Maintenance Center"}
      title={isZh ? "站点维护" : "Site Maintenance"}
      description={isZh ? "把岗位权限维护和运行维护探针放到同一套现代页面壳中，减少旧样式割裂感。" : "Bring position maintenance and runtime probe diagnostics into one modern page shell to remove the old split-layout feel."}
      toolbar={toolbar}
      metrics={metrics}
    >
      <section className="admin-ops-two-column">
        <div className="admin-ops-surface">{leftPanel}</div>
        <div className="admin-ops-surface">{rightPanel}</div>
      </section>
    </AdminOpsShell>
  );
}